import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExciseSubMenu from '@/components/nav/ExciseSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import VideoPopup from '@/components/VideoPopup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form2290SuspendedFree = () => {
  const [open, setOpen] = useState(false);

  // const [isvideoPopupAuto, setvideoPopupAuto] = useState(false);
  const [isvideoPopupSteps, setvideoPopupSteps] = useState(false);

  const openPopupSteps = () => {
    setvideoPopupSteps(true);
  };
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: 'Need to claim a refund using Form 8849?',
  //   SubHeading:
  //     'File it hassle-free and get your money back. E-file now for a quick refund.',
  //   CtaText: 'E-file Form 8849 Now',
  //   CtaSubHeading: `Get your refund now`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290suspendedsticky`,
  //   isActive: true,
  // };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Form 2290 Suspended Vehicle | E-File HVUT Exemption"
          description="File Form 2290 online for suspended vehicles under IRS mileage limits. Claim HVUT exemptions for vehicles driven less than 5,000 miles annually."
          keywords=""
          canonical="excise-tax/free-e-file-form-2290-suspended-vehicles/"
          jsonLdPricing="FREE"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
          ogShareImg="assets/images/excise-share-img.png"
        />
      }
    >
      <ExciseSubMenu />

      <VideoPopup
        isvideoPopup={isvideoPopupSteps}
        setvideoPopup={setvideoPopupSteps}
        src="https://www.youtube.com/embed/QnUmGYD2yLw?autoplay=1&rel=0"
      />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Form 2290 -{' '}
                <span className="highlight-container">
                  <span className="highlight">Suspended Vehicles</span>
                </span>
                {'  '}
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                E-File with Ease | Simplify Your HVUT Filing
              </Typography> */}
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                File{' '}
                <Link
                  href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                  sx={{ color: '#0202ff' }}
                >
                  Form 2290
                </Link>{' '}
                for suspended vehicles online with TaxZerone and get your
                IRS-stamped Schedule 1 copy within minutes.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary medium"
                    sx={{
                      '&.btn-primary.medium': {
                        fontSize: {
                          xs: '15px !important',
                          sm: '20px  !important',
                          md: '17px !important',
                          lg: '20px !important',
                        },
                      },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290suspended`}
                  >
                    Start Filing Now
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Just{' '}
                    <span style={{ color: '#1da94a', fontWeight: 600 }}>
                      $19.99 per
                    </span>{' '}
                    return
                  </Typography>
                </Box>
                <Hidden mdDown>
                  <Box
                    sx={{
                      mb: { xs: '16px !important', sm: '22px !important' },
                    }}
                  >
                    <picture>
                      <source
                        srcSet="/assets/images/irs-authorized.webp"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <source
                        srcSet="/assets/images/irs-authorized.png"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <img
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                    </picture>
                  </Box>
                </Hidden>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              //  className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/2290-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/2290-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/2290-landing-img.png"
                  alt="E-File Form 2290 Suspended Vehicles for FREE"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              //  className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/2290-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/2290-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/2290-landing-img-sm.png"
                  alt="E-File Form 2290 Suspended Vehicles for FREE"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>

      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={{ md: 6, xs: 12 }} textAlign="left">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <Box
                  component="iframe"
                  title="Understanding Suspended Vehicles in Form 2290 | A Complete Guide"
                  src="https://www.youtube.com/embed/0LRvy1oHq1Q?&rel=0"
                  sx={{
                    width: { xs: '100%', sm: 500 },
                    height: { xs: '100%', sm: 281 },
                    border: '10px solid #333 !important',
                    borderRadius: 5,
                  }}
                  allowFullScreen={true}
                />
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is a Suspended Vehicle?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  A{' '}
                  <Link
                    href="/resources/excise-tax/form-2290-taxable-suspended-vehicles/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    suspended vehicle
                  </Link>{' '}
                  is a heavy vehicle that doesn’t meet the mileage threshold set
                  by the IRS, meaning you’re exempt from paying the Heavy
                  Vehicle Use Tax (HVUT). Generally, vehicles that travel fewer
                  than 5,000 miles (7,500 miles for agricultural vehicles)
                  during the tax period are considered suspended and are not
                  required to pay the HVUT.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  However, owners of suspended vehicles still need to file Form
                  2290 to inform the IRS of their exempt status.
                </Typography>

                {/* <Box
                  sx={{
                    width: 'auto',
                    textAlign: 'left',
                    alignItems: 'center',
                    display: 'inline-block',
                    mt: { xs: 2, sm: 2 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary medium"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290suspended`}
                    sx={{transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },}}
                  >
                    File Your Form 2290 Online Now!
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, mb: 0, textAlign: 'center' }}
                    id="auto-magic-2290"
                  >
                    Simplify Your HVUT Filing with TaxZerone!
                  </Typography>
                </Box> */}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          mb: 0,
        }}
      >
        <Container sx={{ maxWidth: '1000px !important' }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Who Qualifies for a Suspended Vehicle Exemption?
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 24, md: 22, sm: 20, xs: 18 },
                  fontWeight: 400,
                  mb: 3,
                  lineHeight: 1.2,
                }}
              >
                Own a heavy vehicle that rarely hits the road? You might qualify
                for a Heavy Vehicle Use Tax (HVUT) exemption!
              </Typography>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={1}
                alignItems="center"
              >
                <Box sx={{ textAlign: 'left', width: '100%', maxWidth: 450 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Here&apos;s who qualifies:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      textAlign: 'left',
                      listStyleType: 'none',
                      p: 0,
                      '& li': {
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                      },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <CheckCircleOutlineIcon sx={{ mr: 1, mb: -0.7 }} />
                      <Box>
                        <b>Vehicle Weight:</b> Your vehicle weighs over 55,000
                        pounds.
                      </Box>
                    </li>
                    <li>
                      <CheckCircleOutlineIcon sx={{ mr: 1, mb: -0.7 }} />
                      <Box>
                        <b>Mileage Limit:</b> You&apos;ve driven less than 5,000
                        miles (or 7,500 miles for agricultural vehicles) in the
                        tax year.
                      </Box>
                    </li>
                  </Box>
                  <Typography variant="body1">
                    If your vehicle meets these criteria, you don’t owe any
                    HVUT. However, you still need to file Form 2290 with the IRS
                    to claim your exemption (Category W).
                  </Typography>
                </Box>

                <Box
                  sx={{
                    '& img': {
                      width: { xs: '100%', sm: 500 },
                      height: { xs: '100%', sm: 281 },
                    },
                  }}
                >
                  <picture>
                    <source
                      srcSet="/assets/images/who-qualify-img.webp"
                      className="img-responsive-banner"
                      width={500}
                      height={281}
                    />
                    <source
                      srcSet="/assets/images/who-qualify-img.png"
                      className="img-responsive-banner"
                      width={500}
                      height={281}
                    />
                    <img
                      src="/assets/images/who-qualify-img.png"
                      alt="Who Qualifies for a Suspended Vehicle Exemption?"
                      width={500}
                      height={281}
                    />
                  </picture>
                </Box>
              </Stack>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mt: 5,
                  mb: 3,
                }}
              >
                Save time! File your Form 2290 with TaxZerone and keep your tax
                filing smooth and easy.
              </Typography>
              <Box component="div" sx={{ margin: 'auto' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: { xs: 0, sm: 0 },
                    mb: { xs: 0, md: 0 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290suspended`}
                >
                  Start Your 2290 Filing Now!
                </Button>
                <Typography
                  variant="body2"
                  sx={{ mt: 1, mb: { xs: 0, md: 0 } }}
                >
                  Get Schedule 1 copy in minutes
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          py: { xs: 1, sm: 3 },
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            pb={4}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                TaxZerone: The Smart Choice for E-filing Form 2290
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Here’s Why:
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt=" Instant & Reliable E-Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant & Reliable E-Filing
                </Typography>
                <Typography variant="body1">
                  TaxZerone provides fast and accurate e-filing for immediate
                  and reliable IRS processing.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-Authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-Authorized
                </Typography>
                <Typography variant="body1">
                  TaxZerone is an IRS-authorized e-file service provider.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="E-file Form 2290"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  E-file Form 2290
                </Typography>
                <Typography variant="body1">
                  Skip the hassle of paper forms - file electronically for
                  faster processing.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Stay compliant"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Stay compliant
                </Typography>
                <Typography variant="body1">
                  Ensure the IRS knows your vehicle is exempt and avoid
                  potential penalties.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Accurate & Secure"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Accurate & Secure
                </Typography>
                <Typography variant="body1">
                  We ensure your information is safe and your filing is
                  error-free.
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={12}
              textAlign="center"
              mt={{ xs: 0, md: 0 }}
              mb={{ xs: 0, sm: 0, md: 0 }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  textAlign: 'center',
                  mb: 3,
                  mt: 5,
                }}
              >
                Choose TaxZerone for a hassle-free, accurate, and secure
                e-filing experience.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxprofessional`}
              >
                Get Your Schedule 1 Today
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Get your IRS-Stamped Schedule 1
                <Hidden smDown mdUp>
                  <br />
                </Hidden>{' '}
                in 3 Simple Steps
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone simplifies Form 2290 e-filing for suspended vehicles,
                so you can get back on the road quickly.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
                cursor: 'pointer',
              }}
              onClick={openPopupSteps}
            >
              <picture>
                <source
                  srcSet="/assets/images/2290-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/2290-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/2290-steps-img.png"
                  alt="Get your IRS-Stamped Schedule 1 for FREE in 3 Simple Steps"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Form information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Form information
                    </Typography>
                    <Typography variant="body1">
                      Provide the required information, such as name, EIN, VIN,
                      taxable gross weight, and first used month (FUM).
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Review the Tax Return"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review the Tax Return
                    </Typography>
                    <Typography variant="body1">
                      Check the information provided for accuracy and make any
                      necessary edits.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Transmit & Get Schedule 1"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Transmit & Get Schedule 1
                    </Typography>
                    <Typography variant="body1">
                      Send your return to the IRS and receive your stamped
                      Schedule 1 as soon as the IRS processes your return.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Let&apos;s recover the refund amount that rightfully belongs to
                you. Take the first step now.
              </Typography> */}
              <Box
                sx={{ textAlign: { xs: 'center', md: 'left' }, maxWidth: 363 }}
              >
                <Button
                  variant="contained"
                  sx={{
                    mt: { xs: 2, sm: 4 },
                    mb: { xs: 0, sm: 0, md: 0 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290suspended`}
                >
                  E-file Form 2290
                </Button>
                <Typography
                  variant="body2"
                  sx={{ mt: 1, mr: { md: 12, xs: 0 }, textAlign: 'center' }}
                >
                  Get Your Schedule 1 Copy Today!
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            flexDirection={{ xs: 'column-reverse', md: 'row' }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 3 }, mt: { xs: -3, md: 3 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  E-File Form 2290 on the Go…
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 2,
                  }}
                >
                  Mobile Apps Tailored for Truckers to E-File Form 2290
                  Effortlessly.
                  <br />
                  <br />
                  Key Features:
                </Typography>
                <Typography component="div" variant="body1" sx={{ mb: 3 }}>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      '& li': {
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        mb: 1.5,
                      },
                    }}
                  >
                    <li>
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <Box>
                        <b>Secure E-Filing:</b> Safely e-file Form 2290 for your
                        suspended vehicles.
                      </Box>
                    </li>
                    <li>
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <Box>
                        <b>Easy Access:</b> Access your filed Form 2290 and
                        Schedule 1 anytime, anywhere.
                      </Box>
                    </li>
                    <li>
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <Box>
                        <b>Instant Confirmation:</b> Receive immediate
                        confirmation and updates on your filing status.
                      </Box>
                    </li>
                    <li>
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <Box>
                        <b>User-Friendly Dashboard:</b> Manage multiple vehicles
                        and businesses with ease.
                      </Box>
                    </li>
                  </Box>
                </Typography>

                <Typography
                  variant="body1"
                  color="secondary"
                  sx={{ fontWeight: 600 }}
                >
                  Install our app today and experience the ultimate convenience
                  of e-filing Form 2290, right from your mobile device!
                </Typography>
                <Box
                  sx={{
                    mt: 2,
                    mb: 1,
                    '& img': {
                      width: { xs: 120, sm: 180 },
                      height: { xs: 37, sm: 55 },
                    },
                  }}
                >
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.taxzerone.excisetaxes"
                    target="_blank"
                    sx={{
                      mr: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Available on the Google Play" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/play-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/play-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/play-store-img.png"
                          alt="Available on the Google Play"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                  <Link
                    href="https://apps.apple.com/us/app/e-file-form-2290-pay-hvut/id6450998674"
                    target="_blank"
                    sx={{
                      ml: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Download on the App Store" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/app-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/app-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/app-store-img.png"
                          alt="Download on the App Store"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                </Box>
                {/* <Typography
                  variant="body2"
                  sx={{ mt: 0, mb: { xs: 2, md: 2 } }}
                >
                  Instant IRS-stamped Schedule 1 copy
                </Typography> */}
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/2290-mobile-app-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/2290-mobile-app-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/2290-mobile-app-img.png"
                    alt="Download TaxZerone’s Form 2290 Mobile App to file easily with the IRS."
                    className="img-responsive"
                    loading="lazy"
                    width={657}
                    height={770}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Save Time and Money with TaxZerone
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Claim Your Tax Exemption for Suspended Vehicles By E-Filing Form 2290
          with the IRS.
        </Typography>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            pb={4}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#fff',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/time-icon.png"
                      alt="Fast & Free E-Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Fast & Accurate E-Filing
                </Typography>
                <Typography variant="body1">
                  Experience quick and precise IRS submissions with
                  TaxZerone&apos;s efficient e-filing service.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#fff',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-Authorized Service"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-Authorized Service
                </Typography>
                <Typography variant="body1">
                  Trust our secure platform to handle your tax exemption filing.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#fff',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="Instant Schedule 1"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Schedule 1
                </Typography>
                <Typography variant="body1">
                  Receive your IRS-stamped Schedule 1 copy in minutes.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              transition: 'all 0.3s ease 0s',
              display: { xs: 'inline-flex', sm: 'inline-flex' },
              '&:hover, &active': {
                transform: 'scale(1.1)',
              },
            }}
            className="btn-primary"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290suspended`}
          >
            E-file Form 2290 Now!
          </Button>
          <Typography
            variant="body2"
            sx={{ mt: 1, mb: { xs: 0, md: 0 } }}
            color="#dfeae1"
          >
            Get Schedule 1 copy in minutes
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. How long does it take to receive the Schedule 1 copy after
                  e-filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography>
                      With TaxZerone, you can receive your{' '}
                      <Link
                        href="/resources/excise-tax/form-2290-schedule-1/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        IRS-stamped Schedule 1
                      </Link>{' '}
                      copy in just minutes after the IRS processes your Form
                      2290.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do I need to file Form 2290 even if my vehicle qualifies
                  for a suspended exemption?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    Yes, owners of suspended vehicles are still required to file
                    Form 2290 with the IRS to inform them of their exempt
                    status. Failure to file may result in penalties and fines.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Can I use TaxZerone to file Form 2290 for vehicles that do
                  not qualify for a suspended exemption?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    Absolutely! TaxZerone supports e-filing for all types of
                    heavy vehicles, whether they qualify for a suspended
                    exemption or not. You can use TaxZerone to fulfill your{' '}
                    <Link
                      href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 2290 filing
                    </Link>{' '}
                    requirements regardless of your vehicle&apos;s status. You
                    can also file{' '}
                    <Link
                      href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 2290 amendments
                    </Link>{' '}
                    and{' '}
                    <Link
                      href="/resources/excise-tax/form-2290-amendments/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 8849
                    </Link>{' '}
                    for your business.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-2290/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form2290SuspendedFree;
